export const IS_IN_DEVELOPMENT = process.env.NODE_ENV === "development";
export const API_URL = IS_IN_DEVELOPMENT ? process.env.REACT_APP_CF_DEV : process.env.REACT_APP_CF_PROD;
